import _SvgIcon from "@mui/material/SvgIcon";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export function EasyIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon, _extends({
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask-easy-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: "100%",
    id: "bg",
    width: "100%",
    x: "0",
    y: "0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16C11.1046 16 12 15.1046 12 14C12 12.8954 11.1046 12 10 12C8.89543 12 8 12.8954 8 14C8 15.1046 8.89543 16 10 16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16C23.1046 16 24 15.1046 24 14C24 12.8954 23.1046 12 22 12C20.8954 12 20 12.8954 20 14C20 15.1046 20.8954 16 22 16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 20.48C10.6054 21.5061 11.4682 22.3564 12.5029 22.9469C13.5377 23.5374 14.7086 23.8476 15.9 23.847C17.1266 23.8473 18.3308 23.518 19.3866 22.8937C20.4424 22.2694 21.3112 21.3729 21.902 20.298",
    stroke: "black",
    strokeWidth: "2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "currentColor",
    mask: "url(#mask-easy-icon)"
  }));
}